import { createGlobalStyle } from 'styled-components'
import { Breakpoints } from './../utils/variables'

import GTAmericaLight from './../fonts/GT-America-Standard-Light.woff'
import GTAmericaRegular from './../fonts/GT-America-Standard-Regular.woff'
import GTAmericaBold from './../fonts/GT-America-Standard-Bold.woff'

const Fonts = createGlobalStyle`
	@font-face {
		font-family: 'GT America Light';
		src: url(${GTAmericaLight}) format('woff');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: 'GT America Regular';
		src: url(${GTAmericaRegular}) format('woff');
		font-weight: normal;
		font-style: normal;
	}

	@font-face {
		font-family: 'GT America Bold';
		src: url(${GTAmericaBold}) format('woff');
		font-weight: normal;
		font-style: normal;
	}

	body {
		font-family: 'GT America Regular', sans-serif;
		font-weight: normal;
		
		-webkit-font-smoothing: antialiased;
		-khtml-font-smoothing: antialiased;
		-apple-font-smoothing: antialiased;
		font-smooth: always;
		
		color: #232325;
	}

	p {
		font-family: 'GT America Light', sans-serif;
		font-size: 13px;
		line-height: 17px;
	}

	@media screen and (min-width: ${Breakpoints.wide}) {
		p {
			font-size: 17px;
			line-height: 27px;
		}
	}
`

export default Fonts